/**
 * @fileoverview หน้า "แบรนด์" (Brand) — master ของโมเดล (models) และอะไหล่
 * (ไม่ใช่ "ซีรีส์" ซึ่งอยู่ที่ series.js — ชั้น "แบรนด์หลัก" ถูกยกเลิกแล้ว แบรนด์จริงถูกรวมเข้าตารางนี้)
 *
 * ชื่อบนหน้าจอ = แบรนด์ (ฟิลด์: รหัสแบรนด์, ชื่อแบรนด์, คำอธิบาย, สถานะ)
 * ข้อมูลจริง   = table `brands` (API: warehouse/brands, permission: brands.*)
 * ความสัมพันธ์ = Brand 1 — N Model (table models.brand_id — ไม่บังคับ บางรุ่นไม่มีแบรนด์)
 * อ้างอิงจาก   = models.brand_id, part_masters.brand_id, bom_masters.brand_id
 *
 * กฎการบันทึก:
 *   - รหัสแบรนด์ / ชื่อแบรนด์ ห้ามว่าง
 *   - trim ช่องว่างหน้า-หลัง + แปลงเป็นตัวพิมพ์ใหญ่ก่อนส่ง (backend ทำซ้ำอีกชั้น)
 *   - รหัสแบรนด์ซ้ำ -> แจ้ง "รหัสแบรนด์นี้มีอยู่แล้ว"
 * Import Excel (Template 04) ทำที่ศูนย์นำเข้าข้อมูล (/wh/import-center) เท่านั้น — หน้านี้ไม่มีปุ่มนำเข้า
 *
 * โครงสร้าง parent_id / level ยังอยู่ใน DB (ข้อมูลเก่า) แต่หน้านี้ไม่ให้สร้างลำดับชั้นใหม่แล้ว
 * ชื่อ field/API/permission ยังใช้คำว่า brand ตามเดิมโดยตั้งใจ (ดู glossary ใน components/global.js)
 */

import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Select,
  t,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";

// ตัดช่องว่างหน้า-หลัง + ตัวพิมพ์ใหญ่ (ใช้กับรหัสแบรนด์และชื่อแบรนด์ก่อนส่ง API)
const normalizeBrandText = (value) => String(value ?? "").trim().toUpperCase();

// แปลงข้อความ error จาก backend ("This Brand Code already exists") เป็นข้อความที่ผู้ใช้เข้าใจ
const brandErrorMessage = (message) => {
  const msg = String(message || "");
  if (/already exists/i.test(msg)) {
    if (/code/i.test(msg)) return t("material_type_code_exists");
    if (/name/i.test(msg)) return t("material_type_name_exists");
  }
  return msg || t("error_occurred");
};

export default class BrandManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
        filter_search: "",
        filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,
      expanded_children: {},

        // Form States (Modal)
        uid: "",
        company_id: company?.id || "", // Default company_id
        brand_code: "",
        name: "",
        description: "",
        is_active: "Active",

        // List Data
        data: [],
        data_brands: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count, data_brands = [];
    loading(true);

    // Call GET API Brands
    let [result, result_brands] = await Promise.all([
        GET("warehouse/brands", {
            page_size: 10,
            page: page,
            data_search: filter_search || "",
            is_active: this.state.filter_status || "",
        }),
        GET("warehouse/brands", {
            page_size: 100000,
            page: 0,
            data_search: filter_search || "",
            is_active: this.state.filter_status || "",
        }),
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }
    if (result_brands?.status) {
      data_brands = result_brands.data;
    }

    this.setState({ data: data || [], count, data_brands: data_brands || [] });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      brand_code,
      name,
      description,
      parent_id,
      is_active,
    } = this.state;

    // Validation: ห้ามว่าง -> trim + ตัวพิมพ์ใหญ่ก่อนบันทึก (กัน TSURUMI / Tsurumi / TSURUMI PUMP ซ้ำกัน)
    const normalized_code = normalizeBrandText(brand_code);
    const normalized_name = normalizeBrandText(name);
    if (!normalized_code) {
      alert("", "warning", t("warning"), t("verify_material_type_code"));
      return;
    } else if (!normalized_name) {
      alert("", "warning", t("warning"), t("verify_material_type_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        brand_code: normalized_code,
        name: normalized_name,
        description: (description || "").trim(),
        parent_id: parent_id || "",
        level: parent_id ? 2 : 1,
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/brands", body)
        : await PUT("warehouse/brands/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert("", "warning", t("warning"), brandErrorMessage(result?.message));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/brands/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      brand_code: "",
      name: "",
      description: "",
      parent_id: "",
      is_active: "Active",
    });
  };

  toggleChildren = (uid) => {
    this.setState((prevState) => ({
      expanded_children: {
        ...prevState.expanded_children,
        [uid]: !prevState.expanded_children[uid],
      },
    }));
  };

  flattenBrands = (brands = []) =>
    brands.reduce((acc, brand) => {
      acc.push(brand);
      if (brand.children?.length) {
        acc.push(...this.flattenBrands(brand.children));
      }
      return acc;
    }, []);

  render() {
    const {
      data,
      count,
      data_brands,
      expanded_children,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      brand_code,
      name,
      description,
      is_active,
    } = this.state;
    const all_brands = this.flattenBrands(data_brands);

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("material_type_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_material_types_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_material_types")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{all_brands.length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf02b"} {/* Tag icon for brand */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_material_types")}</div>
                                    <h4 className="fw-bold text-success mb-0">{all_brands.filter((d) => d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_material_types")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{all_brands.filter((d) => !d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_material_types")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_status")}
                                defaultLabel={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {/* นำเข้าจาก Template 04 ทำที่ศูนย์นำเข้าข้อมูล (/wh/import-center) — หน้านี้ไม่มีปุ่มนำเข้า */}
                        {can("brands.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_material_type")}
                        </button>)}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Brands Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="ps-5 py-3 border-0 wpx-300">{t("material_type")}</th>
                                    <th className="py-3 border-0 wpx-300">{t("description")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>

                            {data.map((item, idx) => (
                                <tbody key={item.uid || idx}>
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Brand Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <button
                                                    type="button"
                                                    className={`btn btn-link p-0 text-16 text-decoration-none d-inline-flex align-items-center justify-content-center wpx-32 hpx-16 ${item.children?.length > 0 ? "text-secondary pointer" : "text-secondary"}`}
                                                    onClick={() => item.children?.length > 0 && this.toggleChildren(item.uid)}
                                                    aria-label={expanded_children[item.uid] ? t("hide_children") : t("show_children")}
                                                    disabled={!item.children?.length}
                                                >
                                                    {item.children?.length > 0 ? (
                                                        <span className="icon fw-bold">
                                                            {expanded_children[item.uid] ? "\uf078" : "\uf054"}
                                                        </span>
                                                    ) : (
                                                        <span className="d-inline-block wpx-16 hpx-16" />
                                                    )}
                                                </button>
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf02b"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.brand_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                                                                <ActionIconButton
                                                    label={can("brands.update") ? t("edit") : t("view")}
                                                    icon={can("brands.update") ? ACTION_ICONS.edit : ACTION_ICONS.view}
                                                    variant={can("brands.update") ? "warning" : "primary"}
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            uid: item.uid,
                                                            brand_code: item.brand_code || "",
                                                            name: item.name || "",
                                                            description: item.description || "",
                                                            parent_id: "",
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                {can("brands.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />)}
                                            </div>
                                        </td>
                                    </tr>
                                      {expanded_children[item.uid] && item.children?.map((child, cidx) => (
                                        <tr key={`${idx}-${cidx}`} className="border-bottom border-light">
                                            <td className="pe-3 bg-secondary-light" style={{ paddingLeft: "65px" }}>
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-secondary`}
                                                    >
                                                        <span className="icon">{"\uf02b"}</span>
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark text-14">{child.name}</div>
                                                        <div className="text-secondary text-10">
                                                            {t("code")}: {child.brand_code}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="bg-secondary-light">
                                                <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }}>
                                                    {child.description || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center bg-secondary-light">
                                                {child.is_active ? (
                                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                ) : (
                                                    <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center bg-secondary-light">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                                                                        <ActionIconButton
                                                        label={can("brands.update") ? t("edit") : t("view")}
                                                        icon={can("brands.update") ? ACTION_ICONS.edit : ACTION_ICONS.view}
                                                        variant={can("brands.update") ? "warning" : "primary"}
                                                        onClick={() => {
                                                            this.setState({
                                                                modal_update: true,
                                                                uid: child.uid,
                                                                brand_code: child.brand_code || "",
                                                                name: child.name || "",
                                                                description: child.description || "",
                                                                is_active: child.is_active ? "Active" : "Inactive",
                                                                parent_id: item.uid,
                                                            });
                                                        }}
                                                    />
                                                    {can("brands.delete") && (
                                                    <ActionIconButton
                                                        label={t("delete")}
                                                        icon={ACTION_ICONS.delete}
                                                        variant="danger"
                                                        onClick={() => {
                                                            this.Delete(child.uid);
                                                        }}
                                                    />)}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ))}
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {fmtInt(count)} {t("material_types_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT BRAND */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_material_type") : t("add_new_material_type")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={(this.state.modal_update && !can("brands.update"))} className="border-0 p-0 m-0" style={(this.state.modal_update && !can("brands.update")) ? { pointerEvents: "none" } : undefined}>
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("material_type_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("material_type_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2 text-uppercase"
                                        placeholder="e.g. TSURUMI"
                                        maxLength={50}
                                        value={brand_code}
                                        onChange={(e) => this.setState({ brand_code: e.target.value })}
                                        onBlur={() => this.setState({ brand_code: normalizeBrandText(brand_code) })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("material_type_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2 text-uppercase"
                                        placeholder="e.g. TSURUMI PUMP"
                                        maxLength={100}
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                        onBlur={() => this.setState({ name: normalizeBrandText(name) })}
                                    />
                                    <small className="text-muted d-block mt-1">{t("brand_uppercase_hint")}</small>
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("material_type_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="brandStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="brandStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
{!(this.state.modal_update && !can("brands.update")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>)}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
